import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  skypointProvidersLoading: false,
  skypointProviders: null,
  skypointProvidersCount: 0
};

export const skypointProvider = createSlice({
  name: "skypointProvider",
  initialState,
  reducers: {
    setSkypointProviderLoading(state, action) {
      return {
        ...state,
        skypointProvidersLoading: action?.payload,
      };
    },
    setSkypointProviders(state, action) {
      return {
        ...state,
        skypointProvidersLoading: false,
        skypointProviders: action?.payload?.providers,
        skypointProvidersCount: action?.payload?.count,
      };
    },
  },
});

export const { setSkypointProviderLoading, setSkypointProviders } =
  skypointProvider.actions;
export default skypointProvider.reducer;
